<template>
  <div
    class="badge bg-opacity-10 text-danger bg-danger p-3 fs-5 fw-normal w-100 text-start text-wrap"
  >
    <div class="d-flex align-items-center">
      <BasePortalIcon icon="warning-solid" class="me-2 warning-solid" />
      <SanitizedText v-if="message" :text="message" />
    </div>
  </div>
</template>

<script setup lang="ts">
import SanitizedText from '@/components/Misc/SanitizedText.vue'

defineProps({
  message: {
    type: String,
    default: undefined,
  },
})
</script>

<style lang="scss" scoped>
.warning-solid {
  min-width: 0.875rem;
  min-height: 0.875rem;
  max-width: 0.875rem;
  max-height: 0.875rem;
  width: 100%;
  height: 100%;
}
</style>
